// slider z bestsellerami - na podstawie OthersAlsoBought
//@ts-nocheck
import React, { FC, useCallback, useEffect, useRef, useState } from 'react';
import { Trans } from 'react-i18next';
import classnames from 'classnames';
import { ArrowLeft, ArrowRight } from 'react-bootstrap-icons';

import { useGetProducts } from 'api';
import { Loader, Container } from 'components/controls';
import ProductCard from 'components/containers/ProductCard/ProductCard';

import styles from 'theme/pages/Home/components/Bestsellers/Bestsellers.module.scss';

const Bestsellers: FC = () => {
  const sliderRef = useRef<HTMLDivElement>(null);
  const [canGoPrev, setCanGoPrev] = useState(false);
  const [canGoNext, setCanGoNext] = useState(false);

  // pobranie listy bestsellerów
  const { data: bestsellersData, isLoading: isBestsellersLoading } = useGetProducts({
    mode: 'BESTSELLERS',
    page: 1,
    limit: 20 // Limit produktów do wyświetlenia
  });

  const products = bestsellersData?.items || [];

  const syncNavState = useCallback(() => {
    const el = sliderRef.current;
    if (!el) return;

    const maxScrollLeft = Math.max(0, el.scrollWidth - el.clientWidth);
    setCanGoPrev(el.scrollLeft > 1);
    setCanGoNext(el.scrollLeft < maxScrollLeft - 1);
  }, []);

  useEffect(() => {
    const el = sliderRef.current;
    if (!el) return;

    syncNavState();
    el.addEventListener('scroll', syncNavState, { passive: true });
    window.addEventListener('resize', syncNavState);

    return () => {
      el.removeEventListener('scroll', syncNavState);
      window.removeEventListener('resize', syncNavState);
    };
  }, [syncNavState, products.length]);

  const scrollPrev = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollBy({ left: -340, behavior: 'smooth' });
      window.setTimeout(syncNavState, 250);
    }
  };

  const scrollNext = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollBy({ left: 340, behavior: 'smooth' });
      window.setTimeout(syncNavState, 250);
    }
  };

  // Hooki muszą być zawsze wywołane w tej samej kolejności
  if (!products.length && !isBestsellersLoading) {
    return null;
  }

  return (
    <div className={classnames(styles.componentWrapper, 'StylePath-Pages-Home-components-Bestsellers')}>
      <Container>
        <div className={styles.sectionTitle}>
          <span className={styles.sectionTitleText}>
            <Trans>Bestsellery</Trans>
          </span>
          <div className={styles.sectionTitleNavigation}>
            <button
              className={classnames(
                styles.navButton,
                styles.back,
                canGoPrev ? styles.active : styles.inactive
              )}
              onClick={scrollPrev}
              aria-label="Poprzednie">
              <ArrowLeft />
            </button>
            <button
              className={classnames(
                styles.navButton,
                styles.next,
                canGoNext ? styles.active : styles.inactive
              )}
              onClick={scrollNext}
              aria-label="Następne">
              <ArrowRight />
            </button>
          </div>
        </div>
      </Container>

      {isBestsellersLoading && <Loader />}

      {products.length > 0 && (
        <div className={styles.sliderWrapper}>
          <Container>
            <div className={styles.slider} ref={sliderRef}>
              {products.map((product) => (
                <div key={product.id} className={styles.slide}>
                  <div className={styles.productWrapper}>
                    <ProductCard product={product} />
                  </div>
                </div>
              ))}
            </div>
          </Container>
        </div>
      )}
    </div>
  );
};

export default Bestsellers;

